import React from "react";
import {
  HashRouter as Router,
  Route,
  Routes,
  Navigate,
  useLocation,
} from "react-router-dom";
import { Spinner } from "react-bootstrap";
import "./App.css";
import BrowseProjects from "./screens/student/BrowseProjects";
import SignUp from "./screens/student/Signup";
import SignIn from "./screens/student/Signin";
import ForgotPassword from "./screens/student/ForgotPassword";
import ResetPassword from "./screens/student/ResetPassword";
import MyProjects from "./screens/student/MyProjects";
import { useUser } from "./contextProviders/userContext";
import AdminProjectsTable from "./screens/admin/AllProjects";
import AdminStudentsView from "./screens/admin/AllStudents";
import AdminProjectDetailView from "./screens/admin/ProjectDetailView";
import AdminDashboard from "./screens/admin/AdminDashboard";
import StudentDashboard from "./screens/student/StudentDashboard";
import OrganizationDashboard from "./screens/organization/OrganizationDashboard";
import OrganizationReports from "./screens/organization/OrganizationReports";
import EmailVerification from "./screens/student/EmailVerification";
import StudentAnnouncementsPage from "./screens/student/ StudentAnnouncementsPage";
import AdminAnnouncementsPage from "./screens/admin/AdminAnnouncementsPage";
import LandingPage from "./screens/common/LandingPage";
import SettingsPage from "./screens/student/SettingsPage";
import HelpCenterPage from "./screens/student/HelpCenterPage";
import DirectMessages from "./screens/common/DirectMessages";
import AdminReports from "./screens/admin/AdminReports";


const ProtectedRoute = ({ children, adminOnly = false, requireRole }) => {
  const { user, loading } = useUser();
  const location = useLocation();

  if (loading) {
    return (
      <div className="d-flex justify-content-center align-items-center vh-100">
        <Spinner animation="border" variant="primary" />
      </div>
    );
  }

  if (!user) {
    return <Navigate to="/signin" state={{ from: location }} replace />;
  }

  if (adminOnly && user.role !== "admin") {
    return <Navigate to="/" replace />;
  }

  if (requireRole && user.role !== requireRole) {
    return <Navigate to="/" replace />;
  }

  return children;
};

const DashboardRouter = () => {
  const { user } = useUser();
  return user?.role === "organization" ? <OrganizationDashboard /> : <StudentDashboard />;
};

const AppContent = () => {
  return (
    <div className="App">
      <main className="app-main">
        <Routes>
          {/* <Route path="/" element={<SignUp />} /> */}
          <Route
            path="/dashboard"
            element={
              <ProtectedRoute>
                <DashboardRouter />
              </ProtectedRoute>
            }
          />
          <Route
            path="/organization/reports"
            element={
              <ProtectedRoute requireRole="organization">
                <OrganizationReports />
              </ProtectedRoute>
            }
          />
          <Route
            path="/browse"
            element={
              <ProtectedRoute>
                <BrowseProjects />
              </ProtectedRoute>
            }
          />
          <Route
            path="/myprojects"
            element={
              <ProtectedRoute>
                <MyProjects />
              </ProtectedRoute>
            }
          />
          <Route path="/signup" element={<SignUp />} />
          <Route path="/signin" element={<SignIn />} />
          <Route path="/forgot-password" element={<ForgotPassword />} />
          <Route path="/reset-password/:token" element={<ResetPassword />} />
          <Route path="/" element={<Navigate to="/dashboard" replace />} />
          <Route path="/verify/:token" element={<EmailVerification />} />

          <Route
            path="/announcements"
            element={
              <ProtectedRoute>
                <StudentAnnouncementsPage />
              </ProtectedRoute>
            }
          />
          <Route
            path="/messages"
            element={
              <ProtectedRoute>
                <DirectMessages />
              </ProtectedRoute>
            }
          />
          <Route
            path="/settings"
            element={
              <ProtectedRoute>
                <SettingsPage />
              </ProtectedRoute>
            }
          />
          <Route
            path="/help"
            element={
              <ProtectedRoute>
                <HelpCenterPage />
              </ProtectedRoute>
            }
          />
          {/* Admin Routes */}
          <Route
            path="/admin"
            element={
              <ProtectedRoute adminOnly={true}>
                <AdminDashboard />
              </ProtectedRoute>
            }
          />
          <Route
            path="/admin/dashboard"
            element={
              <ProtectedRoute adminOnly={true}>
                <AdminDashboard />
              </ProtectedRoute>
            }
          />
          <Route
            path="/admin/projects"
            element={
              <ProtectedRoute adminOnly={true}>
                <AdminProjectsTable />
              </ProtectedRoute>
            }
          />
          <Route
            path="/admin/projects/:projectId"
            element={
              <ProtectedRoute adminOnly={true}>
                <AdminProjectDetailView />
              </ProtectedRoute>
            }
          />
          <Route
            path="/admin/students"
            element={
              <ProtectedRoute adminOnly={true}>
                <AdminStudentsView />
              </ProtectedRoute>
            }
          />

          <Route
            path="/admin/announcements"
            element={
              <ProtectedRoute adminOnly={true}>
                <AdminAnnouncementsPage />
              </ProtectedRoute>
            }
          />
          <Route
            path="/admin/reports"
            element={
              <ProtectedRoute adminOnly={true}>
                <AdminReports />
              </ProtectedRoute>
            }
          />
        </Routes>
      </main>
    </div>
  );
};

function App() {
  return (
    <Router>
      <AppContent />
    </Router>
  );
}

export default App;
